import { DistanceMetrics } from 'src/types'
import { useLocales } from 'src/contexts'
import { LOCALE_DATES } from 'src/constants'

import { useConvertCurrency } from 'src/hooks/useConvertCurrency'
import { useAppSelector } from 'src/hooks/useAppSelector'
import { useAppDispatch } from 'src/hooks/useAppDispatch'

import { userSlice } from 'src/store/reducers/UserReducer/UserSlice'

export const useUserInfoSettings = () => {
  const { translations, locale } = useLocales()

  const { distanceMetric } = useAppSelector(state => state.user)
  const { setDistanceMetric } = userSlice.actions
  const dispatch = useAppDispatch()

  const { date: actualCurrencyDate } = useConvertCurrency()

  function handleDistanceMetricChange(metric: DistanceMetrics): void {
    dispatch(setDistanceMetric(metric))
  }

  function getActualDate(): string {
    const date = new Date(actualCurrencyDate)

    return date.toLocaleDateString(LOCALE_DATES[locale], {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    })
  }

  return {
    locale: translations.setting,
    handleDistanceMetricChange,
    distanceMetric,
    actualCurrencyDate: getActualDate(),
  }
}
